
export default function styles(theme) {
  return {
    section: {
      alignItems: "center",
      justifyContent: "center",
      margin:"10vh 0"
    },
    title: {
      textAlign: "left",
      color: theme.palette.text.highlight,
    },
    stitle: {
      textAlign: "left",
      color: theme.palette.text.primary,
    },
    description: {
      margin: "0rem",
      fontSize: "1rem",
      width: "100%",
      textAlign: "left",
      color: theme.palette.text.tertiary,
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        fontSize: "1rem",
      },
    },
    secondaryTitle: {
      fontSize: "3rem",
      textAlign:"left",
      width: "100%",
      letterSpacing: "1px",
      color: theme.palette.text.primary,
      margin: "0rem",
      padding:"3rem 0rem",
      [theme.breakpoints.down("sm")]: {
        fontSize:  "2rem",
      },
    },
    subTitle:{
      color: theme.palette.text.primary,
      marginBottom: "0.8rem",
    },
    sTitle: {
      textAlign: 'left',
      color: theme.palette.text.tertiary,
      maxWidth: "60%",
      [theme.breakpoints.down("sm")]: {
        maxWidth: "100%",
      },
    },
    heroSection: {
      width: "100%",
      display: "grid",
      gap: "2rem",
      margin: "4rem 0rem",
      gridTemplateColumns:"1fr 2fr",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns:"1fr 1fr",
        margin:"0vh 0 8vh",
      },
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns:"1fr",
        margin:"0vh 0 8vh",
      },
    },
    HeroImageContainer:{
      width:"100%",
      borderRadius:"0 0 30rem 30rem",
      overflow:"hidden",
      backgroundColor: "#151A24",
      border: '1px solid rgb(93,95,255, 0.15)',
      position: "relative",
      height: "100%"
    },
    HeroImage:{
      width: "100%",
      height: "100%",
      transition: "all .5s ease",
      "&:hover": {
        transform: "scale(1.02)",
      }
    },
    circletextcontainer:{
      position: "absolute",
      bottom: "10px",
      zIndex: 1,
    },
    ExpSection: {
      height: "fit-content",
      backgroundSize: "contain",
    },
    ProjectsSection: {
      height: "fit-content",
      backgroundSize: "contain",
      [theme.breakpoints.down("sm")]: {
        marginTop: 30,
      },
    },
    ServicesSection: {
      margin: "10vh 0vh",
      backgroundSize: "contain",
    },
    heroBtns: {
      display: "flex",
      width: "100%",
      justifyContent: "start",
      gap: 20,
      marginTop: 30,
      [theme.breakpoints.down("sm")]: {
        gap: 18,
      },
    },
    communitySection:{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridGap: "4rem",
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "1fr 1fr",
        gridGap: "2rem",
      },
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "1fr",
      },
    },
    leftSection:{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gridGap: "1rem",
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "1fr 1fr",
      },
      [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "1fr",
      },
    },
    card__title:{
      color:theme.palette.text.primary,
      fontWeight: 600,
      fontSize:"1.2rem",
      marginBottom: "0.2rem",
    },
    communityCards:{
      backgroundColor: theme.palette.primary.main,
      padding: "1.5rem",
      borderRadius: "8px",
      border: '1px solid rgba(121, 131, 150, 0.15)',
      [theme.breakpoints.down("sm")]: {
        padding: "1rem",
      },
    },
    secondaryDesc:{
      fontWeight: 100,
      fontSize:"0.8rem",
      fontFamily: "Poppins",
      lineHeight: 1.6,
      color: theme.palette.text.tertiary,
      [theme.breakpoints.down("sm")]: {
        fontSize:"1rem",
      },
    },
    counter:{
      color:'transparent',
      fontWeight: "900",
      fontSize:"3rem",
    },
  };
}
